import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';

interface HotelRankingCalendarsLegendsLegendRankingSignature {
  Args: {};
}

const HotelRankingCalendarsLegendsLegendRanking = <template>
  <div class="ranking-legend-bar">
    <div class="ranking-legend-item text-200--regular ok-green">
      {{t "ranking.legend.green"}}
    </div>
    <div class="ranking-legend-item text-200--regular avg-orange">
      {{t "ranking.legend.orange"}}
    </div>
    <div class="ranking-legend-item text-200--regular nok-red">
      {{t "ranking.legend.red"}}
    </div>
  </div>
</template> satisfies TOC<HotelRankingCalendarsLegendsLegendRankingSignature>;

export default HotelRankingCalendarsLegendsLegendRanking;
